import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          &copy; 2025 Ayham Netfaji — Built with{' '}
          <a 
            href="https://apexonestudios.vercel.app/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            <span className="footer-icon icon-code"></span>
            Apexone Studios
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;